import { cn } from "@/lib/cn";
import type { LiveLogTreeStatusBadgeProps } from "@/types/ui";
import { NodeStatus } from "@shared/types";
import * as styles from "./LiveLogTree.styles";

const MAP: Record<NodeStatus, string> = {
  loading: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  success: "text-emerald-300 bg-emerald-300/10 border-emerald-300/20",
  error: "text-red-400 bg-red-400/10 border-red-400/20",
  pending: "text-muted-foreground bg-muted/10 border-border/20",
  warn: "text-yellow-400 bg-yellow-400/10 border-yellow-400/20",
};

const StatusBadge = ({ status, label }: LiveLogTreeStatusBadgeProps) => {
  return <span className={cn(styles.statusBadgeBase, MAP[status] ?? MAP.pending)}>{label}</span>;
};

export { StatusBadge };
